import { css } from '@emotion/react';
import { type ThemeProps } from '../../../types/themeProps';

export const linkStyle = ({ theme }: ThemeProps) => css({
  color: theme.textColors.link,
  '&:hover': {
    color: theme.textColors.linkOnHover,
  },
});
